import { render, staticRenderFns } from "./dex-mobile.vue?vue&type=template&id=44da4d43&scoped=true"
import script from "./dex-mobile.vue?vue&type=script&lang=ts"
export * from "./dex-mobile.vue?vue&type=script&lang=ts"
import style0 from "./dex-mobile.vue?vue&type=style&index=0&id=44da4d43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44da4d43",
  null
  
)

export default component.exports